import React from 'react';
import { Container, Typography, Box, Card, useTheme, Chip, Accordion, AccordionSummary, AccordionDetails, Grid } from '@mui/material';
import { Security, AccountCircle, MoneyOff, CheckCircle, Support } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const PrivacyPolicy = () => {
  const theme = useTheme();

  const sections = [
    {
      id: 'q1',
      title: "What is our Money Back Guarantee?",
      icon: <MoneyOff />,
      content: [
        {
          text: "Millions of members have successfully found their matches on seethakalyanavaibhogame.com (read the latest success stories!). Our track record of success gives us the confidence to give you this unique guarantee."
        },
        {
          subtitle: "The Guarantee",
          text: "If you have sent at least 10 Interests to members AND you don't have a single Accept WITHIN the first 30 days of becoming a Premium Member, we will refund your entire fee, no questions asked!"
        }
      ]
    },
    {
      id: 'q2',
      title: "What counts as an 'Accept'?",
      icon: <CheckCircle />,
      content: [
        {
          text: "Accepted members are:",
          list: [
            "Members who expressed interest in you and you responded positively",
            "Members who responded positively to your expressed interest"
          ]
        }
      ]
    },
    {
      id: 'q3',
      title: "What are the exclusions?",
      icon: <Security />,
      content: [
        {
          text: "This 30 day money back guarantee is only applicable to online memberships (excluding the Silver plan) & does not apply to our personalized memberships. Personalized membership includes VIP seethakalyanavaibhogame.com and Select seethakalyanavaibhogame membership."
        }
      ]
    },
    {
      id: 'q4',
      title: "What happens after refund?",
      icon: <AccountCircle />,
      content: [
        {
          text: "Premium features will no longer be available once a refund is issued."
        }
      ]
    },
    {
      id: 'q5',
      title: "What do we expect from you?",
      icon: <Support />,
      content: [
        {
          text: "All we expect you to do is fill in all details in your profile, create a partner profile, upload your photo, and actively communicate with members. Can you ask for more? Do write to us."
        }
      ]
    }
  ];

  return (
    <Box sx={{ bgcolor: theme.palette.background.default, minHeight: '100vh' }}>
      {/* Hero Section */}
      <Box sx={{ 
        py: 12,
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
        color: 'white',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <Box
          component="img"
          src="https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2000&q=80"
          alt="Background"
          sx={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            opacity: 0.1,
            top: 0,
            left: 0
          }}
        />
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Box sx={{ mb: 4 }}>
              <MoneyOff sx={{ fontSize: 80, color: 'white' }} />
            </Box>
            <Typography 
              variant="h1" 
              sx={{ 
                fontWeight: 900,
                fontSize: { xs: '2.5rem', md: '4rem' },
                mb: 4,
                textShadow: '0 2px 4px rgba(0,0,0,0.3)'
              }}
            >
              Money Back Guarantee
            </Typography>
            <Typography 
              variant="h5" 
              sx={{ 
                maxWidth: '800px',
                mx: 'auto',
                lineHeight: 1.6,
                opacity: 0.9,
                mb: 6
              }}
            >
              Millions of members have successfully found their matches on seethakalyanavaibhogame.com. Our track record gives us the confidence to give you this unique guarantee.
            </Typography>
            <Chip 
              label="Read the latest success stories!"
              sx={{ 
                bgcolor: 'rgba(255,255,255,0.2)',
                color: 'white',
                fontSize: '1.1rem',
                fontWeight: 600,
                px: 4,
                py: 2
              }}
            />
          </Box>
        </Container>
      </Box>

      {/* Key Guarantee Points - Moved to top for better visibility */}
      <Box sx={{ py: 10, bgcolor: theme.palette.background.paper }}>
        <Container maxWidth="lg">
          <Typography 
            variant="h3" 
            sx={{ 
              textAlign: 'center',
              mb: 6,
              fontWeight: 700,
              color: theme.palette.primary.main
            }}
          >
            Key Guarantee Points
          </Typography>
          <Grid container spacing={4} sx={{ justifyContent: 'center' }}>
            <Grid item xs={12} sm={6} lg={3} sx={{ display: 'flex' }}>
              <Card sx={{ 
                p: 3,
                textAlign: 'center',
                width: '100%',
                minHeight: '180px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                transition: 'all 0.3s ease',
                borderRadius: '12px',
                border: `2px solid ${theme.palette.primary.main}`,
                boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
                '&:hover': {
                  transform: 'translateY(-5px)',
                  boxShadow: '0 12px 30px rgba(0,0,0,0.15)',
                  border: `2px solid ${theme.palette.primary.light}`
                }
              }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                  <MoneyOff sx={{ fontSize: 40, color: theme.palette.primary.main }} />
                </Box>
                <Typography 
                  variant="h6" 
                  sx={{ 
                    fontWeight: 700,
                    color: theme.palette.primary.main,
                    mb: 1.5,
                    fontSize: '1rem'
                  }}
                >
                  30-Day Guarantee
                </Typography>
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: theme.palette.text.secondary,
                    lineHeight: 1.4,
                    fontSize: '0.85rem'
                  }}
                >
                  Full refund if no matches within 30 days
                </Typography>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} lg={3} sx={{ display: 'flex' }}>
              <Card sx={{ 
                p: 3,
                textAlign: 'center',
                width: '100%',
                minHeight: '180px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                transition: 'all 0.3s ease',
                borderRadius: '12px',
                border: `2px solid ${theme.palette.primary.main}`,
                boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
                '&:hover': {
                  transform: 'translateY(-5px)',
                  boxShadow: '0 12px 30px rgba(0,0,0,0.15)',
                  border: `2px solid ${theme.palette.primary.light}`
                }
              }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                  <CheckCircle sx={{ fontSize: 40, color: theme.palette.primary.main }} />
                </Box>
                <Typography 
                  variant="h6" 
                  sx={{ 
                    fontWeight: 700,
                    color: theme.palette.primary.main,
                    mb: 1.5,
                    fontSize: '1rem'
                  }}
                >
                  No Questions Asked
                </Typography>
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: theme.palette.text.secondary,
                    lineHeight: 1.4,
                    fontSize: '0.85rem'
                  }}
                >
                  Simple and straightforward refund process
                </Typography>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} lg={3} sx={{ display: 'flex' }}>
              <Card sx={{ 
                p: 3,
                textAlign: 'center',
                width: '100%',
                minHeight: '180px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                transition: 'all 0.3s ease',
                borderRadius: '12px',
                border: `2px solid ${theme.palette.primary.main}`,
                boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
                '&:hover': {
                  transform: 'translateY(-5px)',
                  boxShadow: '0 12px 30px rgba(0,0,0,0.15)',
                  border: `2px solid ${theme.palette.primary.light}`
                }
              }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                  <Support sx={{ fontSize: 40, color: theme.palette.primary.main }} />
                </Box>
                <Typography 
                  variant="h6" 
                  sx={{ 
                    fontWeight: 700,
                    color: theme.palette.primary.main,
                    mb: 1.5,
                    fontSize: '1rem'
                  }}
                >
                  Full Refund
                </Typography>
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: theme.palette.text.secondary,
                    lineHeight: 1.4,
                    fontSize: '0.85rem'
                  }}
                >
                  Complete refund of your membership fee
                </Typography>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} lg={3} sx={{ display: 'flex' }}>
              <Card sx={{ 
                p: 3,
                textAlign: 'center',
                width: '100%',
                minHeight: '180px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                transition: 'all 0.3s ease',
                borderRadius: '12px',
                border: `2px solid ${theme.palette.primary.main}`,
                boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
                '&:hover': {
                  transform: 'translateY(-5px)',
                  boxShadow: '0 12px 30px rgba(0,0,0,0.15)',
                  border: `2px solid ${theme.palette.primary.light}`
                }
              }}>
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                  <AccountCircle sx={{ fontSize: 40, color: theme.palette.primary.main }} />
                </Box>
                <Typography 
                  variant="h6" 
                  sx={{ 
                    fontWeight: 700,
                    color: theme.palette.primary.main,
                    mb: 1.5,
                    fontSize: '1rem'
                  }}
                >
                  Premium Features
                </Typography>
                <Typography 
                  variant="body2" 
                  sx={{ 
                    color: theme.palette.text.secondary,
                    lineHeight: 1.4,
                    fontSize: '0.85rem'
                  }}
                >
                  Premium features will no longer be available once a refund is issued
                </Typography>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* FAQ Section */}
      <Box sx={{ py: 10, bgcolor: theme.palette.background.default }}>
        <Container maxWidth="lg">
          <Typography 
            variant="h3" 
            sx={{ 
              textAlign: 'center',
              mb: 6,
              fontWeight: 700,
              color: theme.palette.primary.main
            }}
          >
            Guarantee Details
          </Typography>
          {sections.map((section, index) => (
            <Accordion 
              key={section.id}
              sx={{ 
                mb: 3,
                borderRadius: '16px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                '&:before': { display: 'none' },
                '&.Mui-expanded': {
                  margin: '16px 0'
                }
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: theme.palette.primary.main }} />}
                sx={{
                  backgroundColor: theme.palette.background.default,
                  borderRadius: '16px',
                  '&:hover': {
                    backgroundColor: theme.palette.action.hover
                  }
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                  <Box sx={{ 
                    color: theme.palette.primary.main,
                    mr: 2,
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    {section.icon}
                  </Box>
                  <Typography 
                    variant="h6" 
                    sx={{ 
                      fontWeight: 700,
                      color: theme.palette.primary.main,
                      flexGrow: 1
                    }}
                  >
                    {section.title}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 4 }}>
                {section.content.map((item, itemIndex) => (
                  <Box key={itemIndex} sx={{ mb: itemIndex < section.content.length - 1 ? 3 : 0 }}>
                    {item.subtitle && (
                      <Typography 
                        variant="h6" 
                        sx={{ 
                          fontWeight: 600,
                          color: theme.palette.primary.main,
                          mb: 2
                        }}
                      >
                        {item.subtitle}
                      </Typography>
                    )}
                    {item.text && (
                      <Typography 
                        variant="body1" 
                        sx={{ 
                          color: theme.palette.text.secondary,
                          lineHeight: 1.8,
                          mb: item.list ? 2 : 0,
                          fontSize: '1rem'
                        }}
                      >
                        {item.text}
                      </Typography>
                    )}
                    {item.list && (
                      <Box component="ul" sx={{ pl: 3 }}>
                        {item.list.map((listItem, listIndex) => (
                          <Typography 
                            key={listIndex}
                            component="li" 
                            sx={{ 
                              color: theme.palette.text.secondary,
                              lineHeight: 1.8,
                              mb: 1,
                              fontSize: '1rem'
                            }}
                          >
                            {listItem}
                          </Typography>
                        ))}
                      </Box>
                    )}
                  </Box>
                ))}
              </AccordionDetails>
            </Accordion>
          ))}
        </Container>
      </Box>
    </Box>
  );
};

export default PrivacyPolicy;